import { CircularProgress } from '@mui/material'
import * as css from './styles'
import { Phase, PhaseStep } from '../../config'
import { t } from '@lingui/core/macro'

interface Props {
  phase: Phase
  steps: PhaseStep[]
  progressMap: object
}

export const SubmissionStatusRatio = ({ phase, steps, progressMap }: Props) => {
  const totalPhases = steps.length
  const currentPhaseNumber = progressMap[phase]?.progress
  const phasesCompleted =
    currentPhaseNumber === totalPhases ? totalPhases : currentPhaseNumber - 1 || 0
  const progress = (phasesCompleted / totalPhases) * 100

  return (
    <css.Container>
      <CircularProgress
        variant="determinate"
        size={110}
        thickness={2.5}
        value={progress}
        style={{ strokeLinecap: 'round' }}
      />
      <css.PhasesCompletedRatioWrapper>
        <div>
          <css.PhaseText css={css.numerator}>{phasesCompleted}</css.PhaseText>
          <css.PhaseText css={css.delimiter}>/</css.PhaseText>
          <css.PhaseText>{totalPhases}</css.PhaseText>
        </div>
        <css.PhasesCompleted>{t`Phases completed`}</css.PhasesCompleted>
      </css.PhasesCompletedRatioWrapper>
    </css.Container>
  )
}
